module.exports = __webpack_public_path__ + "img/58.946a8483.jpg";